import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector   : 'confirmation-question',
  template: require('./confirmation.question.component.html')
})
export class ConfirmationQuestionComponent {
  @Input() icon   : string;
  @Input() message: string;
  @Input() title  : string;

  constructor (
    public activeModal: NgbActiveModal
  ) {}
}
